import "./Documents.scss";

import {
  Box,
  Card,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  Typography,
} from "@material-ui/core";
import { SaveAlt, Visibility } from "@material-ui/icons";
import { ContentWrapper } from "components/ContentWrapper";
import Navbar from "components/Navbar";
import React from "react";
import { useTranslation } from "react-i18next";

import {
  DocumentType,
  ShowFile,
  showFile,
} from "../../services/fake/fakeDocumentManager";

interface Document {
  title: string;
  file: DocumentType;
}

const DocumentCard = ({
  title, documents
}: any) =>
  <React.Fragment>
    <Typography variant="subtitle2" className="section-title">
      {title}
    </Typography>

    <Card className="card">
      <List>
        {documents &&
          documents.map((
            document: Document, index: number
          ) =>
            <ListItem key={index}>
              <Typography variant="subtitle2" className="width-inherit">
                {document.title}
              </Typography>

              <IconButton
                className="default--auto document-action"
                onClick={() => showFile(
                  ShowFile.Open,
                  document.file
                )}
              >
                <Visibility className="icon" />
              </IconButton>

              <IconButton
                className="default--auto document-action"
                onClick={() => showFile(
                  ShowFile.Download,
                  document.file
                )}
              >
                <SaveAlt className="icon" />
              </IconButton>
            </ListItem>)}

        <Divider />
      </List>
    </Card>
  </React.Fragment>
;
export const Documents = () => {
  const { t } = useTranslation();

  // Options
  const documentCards = [
    {
      title: t("General documents"),
      documents: [
        {
          title: t("Test document"),
          file: DocumentType.General,
        },
      ],
    },
    {
      title: t("Investment documents"),
      documents: [
        {
          title: t("Test document"),
          file: DocumentType.Investment,
        },
      ],
    },
  ];

  return (
    <Box>
      <Navbar />

      <ContentWrapper>
        <Box className="documents">
          <Grid container direction="row" spacing={8}>
            {documentCards &&
              documentCards.map((
                card: any, index: number
              ) =>
                <Grid item xs={12} sm={6} className="section" key={index}>
                  <DocumentCard {...card} />
                </Grid>)}
          </Grid>
        </Box>
      </ContentWrapper>
    </Box>
  );
};
